import { render, staticRenderFns } from "./AcquireDetails.vue?vue&type=template&id=c1add174&scoped=true"
import script from "./AcquireDetails.vue?vue&type=script&lang=js"
export * from "./AcquireDetails.vue?vue&type=script&lang=js"
import style0 from "./AcquireDetails.vue?vue&type=style&index=0&id=c1add174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1add174",
  null
  
)

export default component.exports